import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-625938f0")

_pushScopeId("data-v-625938f0")
const _hoisted_1 = { class: "relay-border-content" }
const _hoisted_2 = { class: "relay-item-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.relayType === 'local' ? _ctx.$wordList.ProperAllTextRelay : _ctx.$wordList.SecurityRelay) + " " + _toDisplayString(_ctx.index+1) + " ", 1),
      _createVNode(_component_el_switch, {
        disabled: _ctx.showAble && _ctx.form.enable,
        "active-text": _ctx.$wordList.ProperAllTextOn,
        "inactive-text": _ctx.$wordList.ProperAllTextOff,
        style: {"float":"right"},
        modelValue: _ctx.form.enable,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.enable = $event)),
        "active-color": "#20a0ff",
        "inactive-color": "#fb602a"
      }, null, 8, ["disabled", "active-text", "inactive-text", "modelValue"])
    ]),
    (_ctx.form.enable)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formEle"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.relayType==='local'?_ctx.$wordList.FormRelayName:_ctx.$wordList.SecurityRelayName,
              prop: "name"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.name = $event)),
                  "auto-complete": "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.type === 'normal')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _ctx.$wordList.FormDTMFCode
                }, {
                  default: _withId(() => [
                    _createVNode(_component_cus_select, {
                      modelValue: _ctx.form.code,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.code = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_cus_option, {
                          label: "0",
                          value: "0"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "1",
                          value: "1"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "2",
                          value: "2"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "3",
                          value: "3"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "4",
                          value: "4"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "5",
                          value: "5"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "6",
                          value: "6"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "7",
                          value: "7"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "8",
                          value: "8"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "9",
                          value: "9"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "#",
                          value: "#"
                        }),
                        _createVNode(_component_cus_option, {
                          label: "*",
                          value: "*"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.showUnlock && _ctx.type === 'normal')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _ctx.$wordList.FormUnlock
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox, {
                      "true-label": "1",
                      "false-label": "0",
                      modelValue: _ctx.form.unlockHomePage,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.unlockHomePage = $event))
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.FormUnlockHomepage), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_checkbox, {
                      "true-label": "1",
                      "false-label": "0",
                      modelValue: _ctx.form.unlockTackPage,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.unlockTackPage = $event))
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.FormUnlockTalking), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"]))
      : _createCommentVNode("", true)
  ]))
})